import { ToolBase, ToolDescription } from "../../../agents/base";
import { createTelemetry, resolveSessionId, unwrapRequest, } from "../readHelpers";
import { TableAnalysisParamsSchema, } from "./tableAnalysis.schema";
const SYSTEM_PROMPT_DESCRIPTION = `### tableAnalysis
Analyze table ranges for patterns and value distributions.`;
export function createTableAnalysisTool(runner, fallbackSessionId) {
    return new TableAnalysisTool(runner, fallbackSessionId).toRuntimeToolDefinition();
}
export class TableAnalysisTool extends ToolBase {
    constructor(runner, fallbackSessionId) {
        super();
        this.runner = runner;
        this.fallbackSessionId = fallbackSessionId;
        this.name = "tableAnalysis";
        this.description = new ToolDescription("tableAnalysis", "Analyze table ranges for patterns and value distributions.", TableAnalysisParamsSchema);
        this.paramsSchema = TableAnalysisParamsSchema;
        this.systemPromptDescription = SYSTEM_PROMPT_DESCRIPTION;
        this.fieldsToCheck = [
            { name: "uiDescription", type: "string", list_status: false, order: 0 },
        ];
        this.listsToCheck = [
            {
                name: "tableAnalysis",
                type: "array",
                item_type: "object",
                list_status: true,
                order: 1,
                check_sub_field: "targetRange",
            },
        ];
    }
    setSessionId(sessionId) {
        this.fallbackSessionId = sessionId;
    }
    async execute(args) {
        const startedAt = Date.now();
        const sessionId = resolveSessionId(args, this.fallbackSessionId);
        const request = unwrapRequest(args);
        const tableAnalysis = request.tableAnalysis || [];
        const result = await this.runner.read({ tableAnalysis }, { sessionId });
        const payload = (result.data || {});
        const tableAnalysisResult = payload.tableAnalysis || [];
        return {
            ...result,
            data: { tableAnalysis: tableAnalysisResult },
            results: { tableAnalysis: tableAnalysisResult },
            telemetry: result.telemetry || createTelemetry(tableAnalysis.length, startedAt),
        };
    }
}
